import Vue from 'vue'
import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { checkNavLimit } from "@/api/basicApi";
import i18n from '@/i18n'

NProgress.configure({
  showSpinner: false,
})

// 黑名单菜单
const blackList = ['/agent/applet/invitation','/agent/applet/subduration','/agent/applet/machinequery','/agent/applet/improvecase','/agent/applet/serviceusers','/agent/applet/courseassigntool','/agent/applet/upgradedurationsta','/agent/applet/exceptionhand','/agent/applet/rank','/agent/applet/studyDayReport','/agent/applet/growthreport','/agent/applet/machinecontrol','/agent/applet/machineusedata','/agent/applet/goldcoinmanage','/agent/applet/agentgoldcoinmanage','/agent/applet/studentgoldcoinmanage','/agent/applet/videocall','/agent/applet/wintergame','/agent/applet/starLevel','/agent/applet/activate','/agent/applet/service','/agent/applet/stockUp','/agent/applet/others']

router.beforeEach(async (to, from, next) => {
  const appTitle = i18n.t('app.title')
  // 始终使用系统标题，不拼接页面名称
  document.title = appTitle
  if (blackList.includes(to.path)) next({ name: 'NoMenu' });
  let CrmMenuKeys = {};
  try {
    CrmMenuKeys = JSON.parse(localStorage.getItem('CRM_MENU_KEYS') || '[]');
  } catch (error) {
    console.error('JSON解析CRM_MENU_KEYS失败');
  }

  if (to.fullPath.indexOf('/#/ssologin') > -1) {
    let ssologin = to.fullPath.replace('/#/ssologin', '/ssologin')
    next(ssologin)
  } else {
    // next()
    // 对菜单进行权限控制
    if (to.path != "/" && to.path != "/main/NoPermission") {
      const  { selectedKeys } = CrmMenuKeys[to.path] || {};
      if (selectedKeys) {
        const { isLimit, reason } = await checkNavLimit({ navId: selectedKeys });
        if (isLimit) {
          next({
            name: 'NoPermission',
            params: { reason },
            replace: false,
          });
          sessionStorage.setItem('no_permission_reason', reason);
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      next();
    }
  }
})
router.afterEach((to, from) => {
  NProgress.done()
  window.scrollTo(0, 0)
})
